let currentUser = null;

export async function checkAuthStatus() {
  try {
    const res = await fetch("/auth/user", {
      credentials: "include",
      headers: {
        "X-CSRF": "1",
      },
    });

    if (res.ok) {
      currentUser = await res.json();
      return currentUser;
    }

    currentUser = null;
    return null;
  } catch (error) {
    currentUser = null;
    return null;
  }
}

export function getCurrentUser() {
  return currentUser;
}

export function getUserId() {
  if (!currentUser || !currentUser.claims) return undefined;
  const claim = currentUser.claims.find(function (c) {
    return c.type === "userId";
  });
  return claim ? claim.value : undefined;
}

export function login(returnUrl) {
  window.location.href =
    "/auth/login?returnUrl=" + encodeURIComponent(returnUrl || "/");
}

export function logout() {
  window.location.href = "/auth/logout";
}
